const Home = () => {
  
return (
  <div className="p-6 space-y-6 text-cyan-950">
    <h2 className="text-2xl font-bold">Welcome to Need Fulfillment</h2>

<h3 className="text-xl">Connecting those in need with those who can help</h3>
<p>
At Needs Fulfillment, we believe in the power of community and support. Our platform connects individuals and organizations with the resources they need to overcome challenges and improve their lives. Whether you’re seeking assistance or looking to lend a helping hand, we’re here to make those connections meaningful and impactful.
</p>
<h3 className="text-xl">How It Works</h3>

<ol><li><strong>Identify Needs</strong>: Easily find individuals and families in your community who need assistance, whether it's food, shelter, medical supplies, or other support.</li>
<li><strong>Offer Help</strong>: Discover opportunities to provide aid based on your capabilities and resources. Every little bit helps, and together we can make a big difference.</li>
<li><strong>Make Connections</strong>: Use our interactive map to see concentrations of needs and connect with those nearby. Your support can reach those who need it most.</li>
</ol>
<h3 className="text-xl">Our Mission</h3>
<p>
Our mission is to bridge the gap between those in need and those willing to help. We strive to create a supportive network where everyone can find the resources they need to thrive.
</p>
  </div>
  );
};

export default Home;
